// src/components/controlRondas/NfcTagSelector.jsx
import React, { useState } from 'react';
import { X, Search, Smartphone, CheckCircle } from 'lucide-react';
import '../styles/NfcTagSelector.scss';

const NfcTagSelector = ({ tags = [], onSelectTag, onCancel, onRefresh }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTagId, setSelectedTagId] = useState(null);
  
  const filteredTags = searchTerm 
    ? tags.filter(tag => 
        tag.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        tag.location?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        tag.tagId?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : tags;
  
  const handleSelect = (tag) => {
    setSelectedTagId(tag.id);
  };
  
  const handleConfirm = () => {
    const selectedTag = tags.find(tag => tag.id === selectedTagId);
    if (selectedTag) {
      onSelectTag(selectedTag);
    }
  };
  
  return (
    <div className="nfc-tag-selector-overlay">
      <div className="nfc-tag-selector">
        <div className="selector-header">
          <h3 className="title">Seleccionar Etiqueta NFC</h3>
          <button
            onClick={onCancel}
            className="btn-close"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="selector-search">
          <Search size={16} className="search-icon" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Buscar etiquetas..."
            className="search-input"
          />
        </div>
        
        <div className="tags-container">
          {filteredTags.length === 0 ? (
            <div className="empty-state">
              <Smartphone size={32} className="empty-icon" />
              <p className="empty-text">
                {searchTerm 
                  ? 'No se encontraron etiquetas que coincidan con tu búsqueda'
                  : 'No hay etiquetas NFC disponibles'}
              </p>
              <p className="empty-subtext">
                {searchTerm 
                  ? 'Prueba a buscar con otros términos'
                  : 'Registra etiquetas NFC en la sección "Etiquetas NFC"'}
              </p>
              {onRefresh && (
                <button
                  onClick={onRefresh}
                  className="btn-refresh"
                >
                  Actualizar Lista
                </button>
              )}
            </div>
          ) : (
            <div className="tags-list">
              {filteredTags.map((tag) => (
                <div 
                  key={tag.id}
                  className={`tag-item ${selectedTagId === tag.id ? 'selected' : ''}`}
                  onClick={() => handleSelect(tag)}
                >
                  <div className="tag-content">
                    <div className="tag-header">
                      <h4 className="tag-name">{tag.name}</h4>
                      {selectedTagId === tag.id && (
                        <CheckCircle size={18} className="selected-icon" />
                      )}
                    </div>
                    
                    <div className="tag-details">
                      <div className="tag-id">
                        <Smartphone size={14} className="tag-icon" />
                        <span>{tag.tagId}</span>
                      </div>
                      
                      {tag.location && (
                        <div className="tag-location">{tag.location}</div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        
        <div className="selector-actions">
          <button
            onClick={onCancel}
            className="btn-cancel"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            className="btn-confirm"
            disabled={!selectedTagId}
          >
            Seleccionar Etiqueta
          </button>
        </div>
      </div>
    </div>
  );
};

export default NfcTagSelector;